import React from 'react'
import { useAppSelector } from '~/hooks/redux'
import PartnersKZ from './kz'
import PartnersRU from './ru'
import PartnersUZ from './uz'

interface IPages {
  RU: React.ReactNode,
  KZ: React.ReactNode,
  UZ: React.ReactNode,
}

const PartnersRouter: React.FC = () => {
  const { country } = useAppSelector(state => state.countryReducer)

  const pages: IPages = {
    RU: <PartnersRU />,
    UZ: <PartnersUZ />,
    KZ: <PartnersKZ />,
  }

  return (
    <>
    {
      !!country?.value ? pages[country.value as keyof React.ReactNode]
      : pages['RU']
    } 
    </>
  )
}

export default PartnersRouter